export default __webpack_public_path__ + "static/media/Training_HeroBanner.9800d324.png";